import React from 'react';
import SingleCarousel from 'components_newui/SingleCarousel/View';
import defaultImgNova from 'img/nova_not_support.jpg';

const IdeaCarousel = ({ images }) => {
  const imageSrc = images?.[0]?.url?.trim() ? images[0].url : defaultImgNova;

  return (
    <SingleCarousel>
      <img
        src={imageSrc}
        alt="thumbnail"
        onError={(e) => {
          e.target.onerror = null;
          e.target.src = defaultImgNova;
        }}
        style={{ 
          width: '100%', 
          height: 'auto' ,
          minWidth: '300px',
          objectFit: 'cover',
          objectPosition: 'top',
          maxHeight: '300px'
        }}
      />
    </SingleCarousel>
  );
};

export default IdeaCarousel;
